<div class="container">
    <div class="row mt-3 mb-3">
        <div class="col">
            <div class="card">
                <form [formGroup]="routerFormGroup" (ngSubmit)="onRouterFormSubmit()">
                    <div class="card-header">
                        Routers
                    </div>
                    <div class="card-body">
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                              <label class="control-label col-form-label-sm">name *</label>
                          </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['name'] }" formControlName="name" />
                                <div *ngIf="validationErrorsArray['name']" class="invalid-feedback">
                                    {{validationErrorsArray['name']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">status *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" formControlName="status">
                                    <option *ngFor="let status of routerStatus" [value]="status.value">
                                        {{status.label}}</option>
                                </select>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                    <label class="control-label col-form-label-sm">router type *</label>
                                </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['routerType'] }" formControlName="routerType">
                                    <option *ngFor="let routerType of routerTypeListApi" [value]="routerType.id">
                                        {{routerType.name}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['routerType']" class="invalid-feedback">
                                    {{validationErrorsArray['routerType']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">channel *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['channel'] }" formControlName="channel">
                                    <option *ngFor="let number of channelNo" [value]="number.value">
                                        {{number.label}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['channel']?.length > 0" class="invalid-feedback">
                                    {{validationErrorsArray['channel']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">master *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['master'] }" formControlName="master" />
                                <div *ngIf="validationErrorsArray['master']?.length > 0" class="invalid-feedback">
                                    {{validationErrorsArray['master']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">network name *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['networkName'] }" formControlName="networkName" />
                                <div *ngIf="validationErrorsArray['networkName']?.length > 0" class="invalid-feedback">
                                    {{validationErrorsArray['networkName']}}
                                </div>
                            </dd>

                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">network password *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['networkPassword'] }" formControlName="networkPassword" />
                                <div *ngIf="validationErrorsArray['networkPassword']?.length > 0" class="invalid-feedback">
                                    {{validationErrorsArray['networkPassword']}}
                                </div>
                            </dd>

                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">router ip *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['routerIp'] }" formControlName="routerIp" />
                                <div *ngIf="validationErrorsArray['routerIp']?.length > 0" class="invalid-feedback">
                                    {{validationErrorsArray['routerIp']}}
                                </div>
                            </dd>

                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">router username *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{ 'is-invalid':validationErrorsArray['routerUsername'] }" formControlName="routerUsername" />
                                <div *ngIf="validationErrorsArray['routerUsername']?.length > 0" class="invalid-feedback">
                                    {{validationErrorsArray['routerUsername']}}
                                </div>
                            </dd>

                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">router password *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': validationErrorsArray['routerPassword']  }" formControlName="routerPassword" />
                                <div *ngIf="validationErrorsArray['routerPassword']?.length > 0" class="invalid-feedback">
                                    {{validationErrorsArray['routerPassword']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                          <dt class="col-sm-3 text-right align-middle">
                              <label class="control-label col-form-label-sm">notes</label>
                          </dt>
                          <dd class="col-sm-3">
                              <textarea class="form-control form-control-sm" formControlName="notes" rows="10"></textarea>
                          </dd>
                        </dl>
                    </div>
                    <div class="card-footer">
                        <a class="btn btn-default btn-sm" href="/hardware/routers">
                            <i class="fa fa-times"></i> <br /> Cancel
                        </a>
                        <button class="btn btn-primary btn-sm float-right" type="submit">
                        <i class="fa fa-save"></i> <br />
                        Save
                    </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
